export default function formatCurrency(
  cents: number,
  { country = 'US', includeUnits = false, showCents = true } = {}
): string {
  if (typeof cents === 'undefined') {
    return null
  }
  const dollars = cents / 100
  const dollarString = showCents ? dollars.toFixed(2) : dollars.toFixed(0)

  if (includeUnits) {
    if (country === 'US') {
      return `$${dollarString}`
    }

    if (country === 'CA') {
      return `$${dollarString} CAD`
    }
  }

  return dollarString
}
